// extracted by mini-css-extract-plugin
module.exports = {"loadingMessageContainer":"HotelBlock_loadingMessageContainer__21n2s","iconSync":"HotelBlock_iconSync__3IW44","fa-spin":"HotelBlock_fa-spin__19jEx"};